// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"1427":"8e70889b","1637":"5bda4a79","3207":"d7d6f1c0","7142":"f0a39469","8397":"20b714e7"}[chunkId] + ".js";
};